<div class="mat-container app-container" fxLayout="column" fxLayoutAlign="space-between stretch" [ngClass.xs]="'mobile'">
  <app-header></app-header>
  <div class="app-container" fxFlex>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
  <app-footer></app-footer>
</div>